import PropTypes from 'prop-types'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

/**
 *
 * @param headerLeft {string|JSX.Element}
 * @param headerRight {string|JSX.Element}
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
export default function CollapsibleList({ headerLeft, headerRight = '', children }) {
  return <>
    <header id="list-titles">
      <Row>
        <Col xs="auto">{headerLeft}</Col>
        <Col className="text-right">{headerRight}</Col>
      </Row>
    </header>

    {children}
  </>
}

CollapsibleList.propTypes = {
	headerLeft : PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
	headerRight: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}
